import { applyMiddleware, compose, createStore } from "redux";
import Cookies from "universal-cookie";
import createSagaMiddleware from "redux-saga";
import { watchTechnicianRequests } from "./technician/technicianSagas";
import { watchTaskRequests } from "./task/taskSagas";
import { watchAssignmentRequests } from "./assignment/assignmentSagas";
import { watchDomainRequests } from "./domain/domainSagas";
import { watchLoginFlow, watchPollTask, watchPollRefreshToken } from "./login/loginSagas";
import { watchBillingActivitiesRequests } from "./billing/billingSagas";
import { watchReasonsRequests } from "./reason/reasonSagas";
import { watchManageLaboureRequests } from "./manageLabourer/manageLabourerSagas";
import { rootReducer } from "./rootReducer";
import { setLocaleLang } from "./domain/domainActions";
import { watchRequestNewDueDateRequests } from "./requestDueDate/requestNewDueDateSagas";
import { watchAttachmentsRequests } from "./attachments/attachmentsSagas";
import { watchFollowUpsRequests } from "./followUps/followUpsSagas";
import { watchAdditionalActionRequests } from "./additionalAction/AdditionalActionSagas";
import { watchActivityQuestions, watchActivityExistingQuestions } from "./activityQuestions/activityQuestionsSagas";

const cookies = new Cookies();

export function configureStore(preloadedState) {
    const sagaMiddleware = createSagaMiddleware();
    const allStoreEnhancers = compose(applyMiddleware(sagaMiddleware));
    const store = createStore(rootReducer, preloadedState, allStoreEnhancers);

    // Start the sagas
    sagaMiddleware.run(watchTechnicianRequests);
    sagaMiddleware.run(watchTaskRequests);
    sagaMiddleware.run(watchAssignmentRequests);
    sagaMiddleware.run(watchDomainRequests);
    sagaMiddleware.run(watchPollTask);
    sagaMiddleware.run(watchLoginFlow);
    sagaMiddleware.run(watchPollRefreshToken);
    sagaMiddleware.run(watchBillingActivitiesRequests);
    sagaMiddleware.run(watchReasonsRequests);
    sagaMiddleware.run(watchRequestNewDueDateRequests);
    sagaMiddleware.run(watchManageLaboureRequests);
    sagaMiddleware.run(watchFollowUpsRequests);
    sagaMiddleware.run(watchAdditionalActionRequests);
    sagaMiddleware.run(watchActivityQuestions);
    sagaMiddleware.run(watchActivityExistingQuestions);
    if (process.env.REACT_APP_FEATURE_FILEUPLOAD === "true") sagaMiddleware.run(watchAttachmentsRequests);

    // request startup data
    if (process.env.REACT_APP_FEATURE_TRANSLATION === "true") {
        const cookiesLocale = cookies.get("locale");
        if (cookiesLocale) {
            store.dispatch(setLocaleLang(cookiesLocale));
        }
    } else {
        store.dispatch(setLocaleLang("en"));
    }

    return store;
}

// Default export for app usage (no preloaded state)
export default configureStore();
